var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import ExperimentResources from "@ane/exp-data/lib/resources/ExperimentResources";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AlertResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy);
  }
  getOperationChecks(experimentId) {
    return __async(this, null, function* () {
      const result = yield ExperimentResources.getOperationChecksForExperiment(experimentId);
      const data = result.isSuccessful() ? result.getSuccessData() : {};
      const r = {
        operationCheckDictionary: data,
        error: result.getError(result),
        errorDetails: result.getError(result),
        lastUpdatedTime: /* @__PURE__ */ new Date()
      };
      return r;
    });
  }
  getExperimentJournal(experimentId) {
    return __async(this, null, function* () {
      const address = `/api/experiments/${experimentId}/journal`;
      const result = yield this._get(address);
      const data = result.isSuccessful() ? result.getSuccessData() : [];
      const r = {
        results: data,
        error: result.getError(result)
      };
      return r;
    });
  }
  getActiveQualityAlerts(experimentId) {
    return __async(this, null, function* () {
      const address = `/api/experiments/${experimentId}/alerts?detailed=true`;
      const result = yield this._get(address);
      const data = result.isSuccessful() ? result.getSuccessData() : {};
      const r = {
        result: data,
        error: result.getError(result),
        id: experimentId
      };
      return r;
    });
  }
  getActiveQualityAlertsVNext(experimentId, workspaceId) {
    return __async(this, null, function* () {
      const address = `/xcardapi/workspaces/${workspaceId}/experiment/${experimentId}/alerts?includeAutoShutdownAlertsOnly=false&api-version=2022-12-01-internal`;
      const result = yield this._get(address);
      const data = result.isSuccessful() ? result.getSuccessData() : {};
      const r = {
        result: data,
        error: result.getError(result),
        id: experimentId
      };
      return r;
    });
  }
  getActiveQualityAlertsVNextV2(experimentId, workspaceId) {
    return __async(this, null, function* () {
      const address = `/xcardapi/workspaces/${workspaceId}/experiment/${experimentId}/alerts?includeAutoShutdownAlertsOnly=false&api-version=2022-12-01-internal`;
      const result = yield this._get(address);
      return result;
    });
  }
  getFeatureActiveQualityAlerts(featureId, workspaceId) {
    return __async(this, null, function* () {
      const address = `/xcardapi/workspaces/${workspaceId}/feature/${featureId}/alerts?includeAutoShutdownAlertsOnly=false&api-version=2022-12-01-internal`;
      const result = yield this._get(address);
      return result;
    });
  }
  resolveQualityAlertsVNext(alertEngageData, action, workspaceId) {
    return __async(this, null, function* () {
      const address = `/xcardapi/workspaces/${workspaceId}/alerts/${action}?api-version=2022-12-01-internal`;
      const result = yield this._patch(alertEngageData, address);
      const data = result.isSuccessful() ? "Passed" : "Failed";
      const r = {
        result: data.value,
        error: result.getError(result)
      };
      return r;
    });
  }
  resolveQualityAlertsVNextV2(alertEngageData, action, workspaceId) {
    return __async(this, null, function* () {
      const address = `/xcardapi/workspaces/${workspaceId}/alerts/${action}?api-version=2022-12-01-internal`;
      const result = yield this._patch(alertEngageData, address);
      return result;
    });
  }
};
AlertResources = __decorateClass([
  WPSProxyConverter()
], AlertResources);
const AlertResources$1 = new AlertResources();
export {
  AlertResources,
  AlertResources$1 as default
};
//# sourceMappingURL=AlertResources.js.map
